import { Logo, useDocumentTitle } from "@unizpay/ui";
import { Link } from "react-router";

export function NotFoundPage() {
  useDocumentTitle("Page not found");
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center px-4 py-10">
      <Logo className="mb-8 h-9" />
      <main className="w-full max-w-sm rounded-lg border border-line bg-surface px-6 py-7 text-center shadow-sm">
        <p className="text-[0.8125rem] font-semibold text-accent">404</p>
        <h1 className="mt-1 text-lg font-semibold">Page not found</h1>
        <p className="mt-1.5 text-[0.8125rem] text-fg-muted">
          The page you are looking for does not exist or has moved.
        </p>
        <Link
          to="/dashboard"
          className="mt-6 inline-flex h-10 w-full items-center justify-center rounded-md bg-accent px-4 text-sm font-medium text-accent-fg shadow-sm hover:bg-accent-hover"
        >
          Go to dashboard
        </Link>
      </main>
    </div>
  );
}
